import * as styles from "../../../../styles/DefaultSetting";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert";


interface BoxModifyProps {
	setModal: (modal: number) => void;
	setInsect: any;
	insect: any;
	setChangeBoxName: any;
	changeBoxName: any;
	changeBoxInfo: any;
	setActionComplete: (actionComplete: boolean) => void;
}

const BoxModify: React.FC<BoxModifyProps> = ({
	setModal, setInsect, insect, setChangeBoxName, changeBoxName, changeBoxInfo, setActionComplete
}) => {
	let [insectList, setInsectList] = useState<any>(); // 곤충리스트
	
	// 완료 시 초기화 하는 함수
	const clearReset = () => {
		setModal(0);
		setInsect('');
		setChangeBoxName('');  // 이동할 장소
		setInsectList([]); // 현재 선택된 BOX
		setActionComplete(true); // 액션 완료
	};


  useEffect(() => {
    axios
      .get(`/ifactory/api/productcode`)
      .then((res) => {
        setInsectList(res.data);
      })
      .catch((error) => {
        confirmAlert({
					title: error.response.data,
					buttons: [{ label: "Yes" }],
				});
      });

    setChangeBoxName(changeBoxInfo.boxName);
    setInsect(changeBoxInfo.productCode);
  }, []);

  const BoxName = (e: any) => {
    setChangeBoxName(e.target.value);
  };
  const SelectHandler = (e: any) => {
    setInsect(e.target.value);
  };

  const BoxChangeSubmit = () => {
		axios
			.put(`/ifactory/api/managebox/${changeBoxInfo.manageBoxId}`, {
        boxName: changeBoxName,
        productCode: insect,
      })
			.then((res) => {
				confirmAlert({
					title: res.data,
					buttons: [
						{
							label: '확인',
							onClick: () => {
								clearReset();
							}
						}
					]
				});
      })
      .catch((error) => {
				confirmAlert({
					title: error.response.data.message,
					buttons: [
						{
							label: '확인',
							onClick: () => {
								clearReset();
							}
						}
					]
				});
			});
  };

  return (
    <styles.ModalContainer>
      <styles.BoxModifyModal>
        <div className="input-list">
          <p className="input-name">상자명</p>
          <input type="text" value={changeBoxName} onChange={BoxName} />
        </div>
        <div className="input-list">
          <p className="input-name">곤충명</p>
          <select name="insect" value={insect} onChange={SelectHandler}>
            {insectList &&
							insectList.map((Insect: any, idx: number) => <option value={Insect.productCode} key={idx}>{Insect.productName}</option>)
						}
          </select>
        </div>
        <div className="btn-box">
          <button onClick={() => { BoxChangeSubmit(); }}>확인</button>
          <button onClick={() => { setModal(0); }}>취소</button>
        </div>
      </styles.BoxModifyModal>
    </styles.ModalContainer>
  );

};

export default BoxModify;
